var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_958_85250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_958_85250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_958_85250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_958_85250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_958_85250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.44748 5.95752H1.83331C1.5681 5.95752 1.31374 6.06288 1.12621 6.25041C0.93867 6.43795 0.833313 6.6923 0.833313 6.95752V13.5834C0.833313 13.8486 0.93867 14.1029 1.12621 14.2905C1.31374 14.478 1.5681 14.5834 1.83331 14.5834H5.44748C5.7127 14.5834 5.96705 14.478 6.15459 14.2905C6.34212 14.1029 6.44748 13.8486 6.44748 13.5834V6.95752C6.44748 6.6923 6.34212 6.43795 6.15459 6.25041C5.96705 6.06288 5.7127 5.95752 5.44748 5.95752ZM5.28665 8.92919C4.96226 9.22766 4.68171 9.5705 4.45331 9.94752C4.17377 10.3841 3.95719 10.8579 3.80998 11.355C3.67276 11.7865 3.59948 12.2357 3.59248 12.6884H2.65998C2.68483 12.0423 2.83128 11.4068 3.09165 10.815C3.35694 10.1885 3.72475 9.61062 4.17998 9.10502H1.98498V8.31585H5.28498L5.28665 8.92919Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8075 5.95752H8.19415C7.92894 5.95752 7.67458 6.06288 7.48705 6.25041C7.29951 6.43795 7.19415 6.6923 7.19415 6.95752V13.5834C7.19415 13.8486 7.29951 14.1029 7.48705 14.2905C7.67458 14.478 7.92894 14.5834 8.19415 14.5834H11.8075C12.0727 14.5834 12.3271 14.478 12.5146 14.2905C12.7021 14.1029 12.8075 13.8486 12.8075 13.5834V6.95752C12.8075 6.6923 12.7021 6.43795 12.5146 6.25041C12.3271 6.06288 12.0727 5.95752 11.8075 5.95752ZM11.6467 8.92919C11.3222 9.22757 11.0416 9.57042 10.8133 9.94752C10.5344 10.385 10.3186 10.8597 10.1725 11.3575C10.0356 11.789 9.96255 12.2382 9.95582 12.6909H9.02249C9.0473 12.0448 9.19375 11.4093 9.45415 10.8175C9.71955 10.1913 10.0874 9.61372 10.5425 9.10835H8.34832V8.31919H11.6483L11.6467 8.92919Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1658 5.95752H14.5525C14.2873 5.95752 14.0329 6.06288 13.8454 6.25041C13.6578 6.43795 13.5525 6.6923 13.5525 6.95752V13.5834C13.5525 13.8486 13.6578 14.1029 13.8454 14.2905C14.0329 14.478 14.2873 14.5834 14.5525 14.5834H18.1658C18.431 14.5834 18.6854 14.478 18.8729 14.2905C19.0605 14.1029 19.1658 13.8486 19.1658 13.5834V6.95752C19.1658 6.6923 19.0605 6.43795 18.8729 6.25041C18.6854 6.06288 18.431 5.95752 18.1658 5.95752ZM18.005 8.92919C17.6805 9.22757 17.3999 9.57042 17.1717 9.94752C16.892 10.3841 16.6754 10.8579 16.5283 11.355C16.3911 11.7864 16.3178 12.2357 16.3108 12.6884H15.3783C15.403 12.0423 15.5495 11.4067 15.81 10.815C16.0765 10.1892 16.4454 9.61208 16.9017 9.10752H14.7067V8.31835H18.0067L18.005 8.92919Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_958_85250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlot);
export default __webpack_public_path__ + "static/media/icon-slot.8ff9e2e7929a429f931afb5aa03e69bf.svg";
export { ForwardRef as ReactComponent };